export { default } from './CommentsService';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/comments/services/index.js